var data = { breakpoints:{ values:{ xs:0,
      sm:320,
      md:414,
      lg:768,
      xl:1024 },
    unit:"px",
    step:5 } };
data.breakpoints;

export default data;
//# sourceMappingURL=breakpoints.yaml.js.map
